import Page from "../../components/Page";
import useConclusionsList from "./hooks/useConclusionsList";

const ConclusionsList = () => {
  const page = useConclusionsList();
  return <Page {...page} />;
};

export default ConclusionsList;
